import { YStack } from "tamagui";

import { LoadingSpinner, Paragraph, Text } from "@/components";

export const PrescriptionAnalysis = () => {
  return (
    <YStack
      flex={1}
      alignItems="center"
      justifyContent="center"
      gap="$150"
      paddingHorizontal="$200"
      paddingBottom="$200"
    >
      <LoadingSpinner size="$1000" />
      <Text semibold size="$md">
        Reading your label...
      </Text>
      <Paragraph color="$textSecondary" size="$s" textAlign="center">
        This usually takes just a few seconds.
      </Paragraph>
    </YStack>
  );
};
